import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, FormattedMessage } from 'react-intl';
import { arrayOf, bool, shape, string } from 'prop-types';
import { loadData } from './SubscriptionInboxPage.duck';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { IconSpinner, InboxWrapper, PaginationLinks } from '../../components';
import SubscriptionItem from './SubscriptionItem/SubscriptionItem';
import ServiceFeeFilters from './ServiceFeeFilters/ServiceFeeFilters';
import { parse } from '../../util/urlHelpers';

import css from './SubscriptionInboxPage.css';

//A fee with the 'declined' status is an unpaid and canceled fee.
const stateOptions = [
  { value: "all", label: "ServiceFeeFilters.allFees", className: null },
  { value: "pending", label: "ServiceFeeFilters.pendingPayment", className: css.pending },
  { value: "declined", label: "ServiceFeeFilters.declined", className: css.expired },
  { value: "accepted", label: "ServiceFeeFilters.accepted", className: css.accepted },
  { value: "cancelled", label: "ServiceFeeFilters.cancelled", className: css.cancelled },
];

const SubscriptionInboxPageComponent = (props) => {
  const {
    fetchInProgress,
    fetchServiceFeesError,
    fetchServiceFeesSuccess,
    intl,
    pagination,
    params,
    location,
    scrollingDisabled,
    transactions,
    currentUserProviders,
    history,
    name,
    currentUser
  } = props;
  const { tab, providerId } = params;
  const isOrders = tab === "orders";
  const type = isOrders ? "order" : "sale";

  const error = fetchServiceFeesError ? (
    <p className={css.error}>
      <FormattedMessage id="SubscriptionInboxPage.fetchFailed" />
    </p>
  ) : null;

  const noResults =
    !fetchInProgress && transactions.length === 0 && !fetchServiceFeesError ? (
      <p key="noResults" className={css.noResults}>
        <FormattedMessage
          id={isOrders ? "SubscriptionInboxPage.noOrdersFound" : "SubscriptionInboxPage.noSalesFound"}
        />
      </p>
    ) : null;

  const pagingLinks =
    !fetchInProgress && pagination && pagination.totalPages > 1 ? (
      <PaginationLinks
        className={css.pagination}
        pageName="SubscriptionInboxPage"
        pagePathParams={params}
        pageSearchParams={parse(location.search)}
        pagination={pagination}
      />
    ) : null;

  return (
    <InboxWrapper
      currentUserProviders={currentUserProviders}
      intl={intl}
      scrollingDisabled={scrollingDisabled}
      name={name}
      tab={tab}
      currentUser={currentUser}
    >
      <>
        {error}
        <ServiceFeeFilters
          location={location}
          isOrders={isOrders}
          history={history}
          // TEMP - hide providers without homeDelivery for subscription test
          currentUserProviders={currentUserProviders.filter(p => p.attributes.deliveryToHome)}
          providerId={providerId}
          intl={intl}
          stateOptions={stateOptions}
        />
        <ul className={css.itemList}>
          {!fetchInProgress ? (
            transactions.map(transaction => (
                <SubscriptionItem intl={intl} transaction={transaction} type={type} stateOptions={stateOptions}/>
            ))
          ) : (
            <li className={css.listItemsLoading}>
              <IconSpinner />
            </li>
          )}
          {noResults}
        </ul>
        {pagingLinks}
      </>
    </InboxWrapper>
  )
}
const mapStateToProps = state => {
  const {
    fetchInProgress,
    fetchServiceFeesError,
    fetchServiceFeesSuccess,
    pagination,
    serviceFees,
  } = state.SubscriptionInboxPage;

  const { currentUser, userProviders: currentUserProviders } = state.user;

  return {
    currentUser,
    currentUserProviders,
    fetchInProgress,
    fetchServiceFeesError,
    fetchServiceFeesSuccess,
    pagination,
    scrollingDisabled: isScrollingDisabled(state),
    transactions: getMarketplaceEntities(state, serviceFees),
  };
};

const SubscriptionInboxPage = compose(
  connect(mapStateToProps),
  injectIntl,
  withRouter
)(SubscriptionInboxPageComponent);

SubscriptionInboxPage.loadData = loadData;

export default SubscriptionInboxPage;
